/* eslint-disable max-classes-per-file,no-underscore-dangle */
export class AppError extends Error {
  protected _exceptionClass: string

  constructor(message: string) {
    super(message)
    this._exceptionClass = 'AppError'
  }

  get exceptionClass(): string {
    return this._exceptionClass
  }
}

export class NotImplementedError extends AppError {
  constructor(message?: string) {
    super(message || 'NotImplementedError')
    this._exceptionClass = 'NotImplementedError'
  }
}
